import * as ls from "local-storage";
import axios from 'axios';
import env from '../ENV';
const ROOT_URL = env.BACKEND_URL;

class AuthHandler {
    constructor() {
        this.authDetails = ls.get("authDetails");
        this.validateToken();
    }

    validateToken() {
        let token = this.getToken();
        if (token == "") {
            window.location.href = env.LOGIN_URL;
        }
    }

    getRoles = () => {
        return this.parsePayload('roles');
    }

    getGroups = () => {
        return this.parsePayload('groups');
    }

    getPermissions = () => {
        return this.parsePayload('permissions');
    }

    getUserID = () => {
        return this.parsePayload('userId');
    }

    parsePayload = (prop) => {
        try {
            let userPayload = this.getUserPayLoad();
            // console.log("userPayload",userPayload);
            let propVal = userPayload && userPayload != "" ? userPayload[prop] : [];
            if(Array.isArray(propVal))
            return propVal.reduce((ac, a) => ({
                ...ac,
                [a]: true
            }), {});
            else
                return propVal;
        } catch (e) {
            return {};
            console.log(e);
        }
    }

    getUserPayLoad = () => {
        try {
            let token = this.getToken();
            let explodeDetail = token.split('.');
            let payloadDetail = explodeDetail && explodeDetail.length > 0 ? explodeDetail[1] : "";
            return JSON.parse(atob(payloadDetail));
        } catch (e) {
            console.log(e);
        }
    }

    getToken = () => {
        return this.authDetails && this.authDetails.accessToken ? this.authDetails.accessToken : "";
    }

    renewToken = async() => {
        try {
            let authDetails = this.authDetails; //{...this.authDetails,secret:'sT4O9gpa3S'};
            authDetails.secret = 'sT4O9gpa3S'
            console.log("authDetails", authDetails);
            let res = await axios.post(`${ROOT_URL}auth/renew`, authDetails);
            this.authDetails = res.data;
            ls.set("authDetails", this.authDetails);
            return this.authDetails;

        } catch (e) {
            console.log("Error renewToken: ", e);
        }
    }

    validateTokenExp = async()=>{
        try{
            let userPayload = this.getUserPayLoad();
            let exp = userPayload && userPayload.exp ? userPayload.exp :null
            if(exp && Date.now()<exp){
                window.location.href = env.LOGIN_URL;
            }
        
        }catch(e){
            console.log("ERROR",e);
        }
    }
}

export default new AuthHandler();